<ng-template #applicationItemTemplate let-item>
	<ng-template #applicationItemContentTemplate>
		<img alt="illustration" *ngIf="item.picture" [src]="item.picture" [alt]="item.name" loading="lazy" />
		<mat-icon *ngIf="item.svgIcon" [svgIcon]="item.svgIcon" class="{{item?.class}}"></mat-icon>
		<mat-icon *ngIf="item.icon" class="{{item?.class}}">{{item.icon}}</mat-icon>
        {{item.name}}
	</ng-template>
	<ng-template #applicationItemActionContentTemplate let-action>
		<mat-icon *ngIf="action.icon">{{action.icon}}</mat-icon>
		{{action.label}}
	</ng-template>
	<ng-container *ngIf="item.actions?.length === 1">
		<a mat-button *ngIf="item.actions[0].url" [attr.href]="item.actions[0].url" rel="noopener">
			<ng-container *ngTemplateOutlet="applicationItemContentTemplate"></ng-container>
		</a>
		<a mat-button *ngIf="item.actions[0].link" [routerLink]="item.actions[0].link">
			<ng-container *ngTemplateOutlet="applicationItemContentTemplate"></ng-container>
		</a>
		<button mat-button *ngIf="item.actions[0].onClick" (click)="item.actions[0].onClick()">
			<ng-container *ngTemplateOutlet="applicationItemContentTemplate"></ng-container>
		</button>
	</ng-container>
	<ng-container *ngIf="item.actions?.length > 1">
		<mat-menu #appMenu="matMenu" overlapTrigger>
			<ng-container *ngFor="let action of item.actions">
				<a mat-menu-item *ngIf="action.url" [attr.href]="action.url" rel="noopener">
					<ng-container *ngTemplateOutlet="applicationItemActionContentTemplate; context:{$implicit: action}"></ng-container>
				</a>
				<a mat-menu-item *ngIf="action.link" [routerLink]="action.link">
					<ng-container *ngTemplateOutlet="applicationItemActionContentTemplate; context:{$implicit: action}"></ng-container>
				</a>
				<button mat-menu-item *ngIf="action.onClick" (click)="action.onClick()">
					<ng-container *ngTemplateOutlet="applicationItemActionContentTemplate; context:{$implicit: action}"></ng-container>
				</button>
			</ng-container>
		</mat-menu>
		<button mat-button [matMenuTriggerFor]="appMenu">
			<ng-container *ngTemplateOutlet="applicationItemContentTemplate"></ng-container>
		</button>
	</ng-container>
</ng-template>

<ng-template #waitingPosts>
    <div fxLayout="row" fxLayoutAlign="start center" style="padding: 8px 16px" *ngFor="let i of [].range(10)">
        <ngx-skeleton-loader [theme]="{'width.px': 75, 'height.px': 75, 'border-radius.px': 16}"></ngx-skeleton-loader>
        <div>
            <ngx-skeleton-loader [theme]="{'width.px': 150, 'margin-left.px': 8}"></ngx-skeleton-loader>
            <ngx-skeleton-loader [theme]="{'width.px': 100, 'margin-left.px': 8}"></ngx-skeleton-loader>
        </div>
    </div>
</ng-template>

<div fxLayout="row" fxLayout.lt-md="column" fxLayoutAlign="start stretch">
    <div fxLayout="column" style="flex: 1">
        <div id="top" class="app-section app-section-backround-home app-section-xl">
            <div class="app-section-content">
                <div class="mat-title mat-accent-gradient">
                    Bienvenue sur le Portail Oxance
                </div>
                <div fxLayout="row wrap" style="gap: 8px">
                    <a mat-flat-button color="accent" routerLink="/home/mon-espace">Mon espace</a>
                    <a mat-flat-button color="accent" routerLink="/communication-generale">Communication direction générale</a>
                    <a mat-flat-button color="accent" routerLink="/rh/jobs">Mobilité interne</a>
                </div>
            </div>
        </div>

        <!-- <div class="app-section">
            <div class="app-section-content">
                Si vous chercher de l'aide, nous vous invitons à consulter <a routerLink="/home/faq">la F.A.Q.</a> ou à 
                <a (click)="openDemande()">ouvrir une nouvelle demande</a>.
            </div>
        </div> -->

        <div id="mon-espace" class="app-section" fxLayout="column" fxLayoutAlign="stretch center"
            style="position: relative; z-index: 2">
            <div class="app-section-content app-section-content-xl">
                <div class="mat-title mat-accent-gradient">
                    Mon espace
                </div>
                <div fxLayout="row wrap" fxLayout.xs="column" fxLayoutAlign="start stretch" style="gap: 24px">

                    <div fxLayout="column" fxLayoutAlign="space-between">
                        <mat-card fxFlex="0 1 140px" fxFlex.xs="1 1 auto" class="mat-elevation-z-1 app-section-backround-parcours-patient"
                            fxLayout="column" fxLayoutAlign="space-between">
                            <mat-list fxLayoutAlign="center">
                                <div mat-subheader class="mat-accent-dark">Parcours patient</div>
                            </mat-list>
                            <mat-card-actions fxLayoutAlign="center">
                                <a mat-flat-button color="accent" class="mat-accent-dark" routerLink="/leave/parcours-patient" style="margin-left: auto"
                                    data-umami-event="Click on Parcours patient">
                                    Consulter
                                    <mat-icon>navigate_next</mat-icon>
                                </a>
                            </mat-card-actions>
                        </mat-card>

                        <mat-card fxFlex="0 1 140px" fxFlex.xs="1 1 auto" class="mat-elevation-z-1 app-section-backround-guide-veasy"
                            fxLayout="column" fxLayoutAlign="space-between">
                            <mat-list fxLayoutAlign="center">
                                <div mat-subheader class="mat-accent-dark">Espace de suivi Veasy</div>
                            </mat-list>
                            <mat-card-actions fxLayoutAlign="center">
                                <a mat-flat-button color="accent" class="mat-accent-dark" routerLink="/leave/guide-veasy" style="margin-left: auto"
                                    data-umami-event="Click on Espace de suivi Veasy">
                                    Consulter
                                    <mat-icon>navigate_next</mat-icon>
                                </a>
                            </mat-card-actions>
                        </mat-card>
                    </div>

                    <mat-card class="mat-elevation-z0" fxFlex="1 0 250px" fxFlex.xs="1 1 auto">
                        <mat-list>
                            <div mat-subheader>Applications</div>
                        </mat-list>
                        <mat-card-content fxLayout="row wrap" class="app-apps">
                            <ng-container *ngFor="let item of applications">
                                <ng-container *ngTemplateOutlet="applicationItemTemplate; context:{$implicit: item}"></ng-container>
                            </ng-container>
                        </mat-card-content>
                    </mat-card>

                    <mat-card class="mat-elevation-z0" fxLayout="column" fxFlex="0 1 250px" fxFlex.xs="1 1 auto">
                        <mat-list>
                            <div mat-subheader class="mat-green">Mes demandes d'interventions</div>
                        </mat-list>
                        <mat-card-content fxLayout="row wrap" fxFlex="1 1 0" fxLayoutAlign="center center" class="app-apps">
                            <button mat-button class="mat-green" (click)="openDemande()" id="demandes-button-new">
                                <mat-icon>add_comment</mat-icon>
                                Nouvelle Demande
                            </button>
                        </mat-card-content>
                        <mat-card-actions fxLayoutAlign="center">
                            <a mat-button routerLink="/demandes">
                                Voir mes demandes
                                <mat-icon>navigate_next</mat-icon>
                            </a>
                        </mat-card-actions>
                    </mat-card>
                </div>
            </div>
        </div>

        <div class="app-section">
            <div class="app-section-content">
                <div class="mat-title mat-accent-gradient" style="position: relative; padding: 8px; margin: 0 0 8px -8px">
                    Support de communication Oxance
                </div>
                <mat-card class="mat-elevation-z0">
                    <mat-card-actions fxLayout="row wrap" fxLayoutAlign="space-between center" style="padding: 0; margin: 0px">
                        <div>Retrouvez ici tous les templates PowerPoint, Word, les logos et affiches pour vos communications.</div>
                        <a mat-button routerLink="/communication-tools" style="position: relative" data-umami-event="Click on Support de communication">
                            Consulter <mat-icon>navigate_next</mat-icon>
                        </a>
                    </mat-card-actions>
                </mat-card>
            </div>
        </div>

        <div id="faq" class="app-section app-section-xl">
            <div class="app-section-content">
                <div class="mat-title mat-accent-gradient">
                    F.A.Q.
                </div>
                <mat-accordion style="flex: 1">
                    <mat-expansion-panel class="mat-elevation-z0">
                        <mat-expansion-panel-header>
                            <mat-panel-title>Comment modifier mon mot de passe ?</mat-panel-title>
                        </mat-expansion-panel-header>
                        <ng-template matExpansionPanelContent>
                            <div fxLayout="row" class="mat-grey" style="gap: 8px; margin-bottom: 16px">
                                <img src="assets/Backhand Index Pointing Right.png" fxFlex="0 0 24px" style="height: 24px" />
                                <p>
                                    Nous vous conseillons d'ouvrir la procedure dans un nouvel onglet (click molette) et de mettre les 2 fenetres cote à cote.
                                </p>
                            </div>
                            Pour modifier votre mot de passe, vous pouvez suivre 
                            <a href="https://gcmutualitefr.sharepoint.com/sites/PortailOxance/Documents%20partages/Public/Aide%20sur%20le%20Portail/Changer%20son%20Mot%20de%20Passe.pdf">cette procédure</a>.
                        </ng-template>
                    </mat-expansion-panel>
                    <mat-expansion-panel class="mat-elevation-z0">
                        <mat-expansion-panel-header>
                            <mat-panel-title>Comment ouvrir une nouvelle demande d'intervention ?</mat-panel-title>
                        </mat-expansion-panel-header>
                        <ng-template matExpansionPanelContent>
                            <p>
                                Suivez notre guide pas à pas qui vous aidera à ouvrir une nouvelle demande d'intervention.<br />
                                Démarrez maintenant en <a (click)="demandesIntroReplay()">cliquant ici</a>.
                            </p>
                        </ng-template>
                    </mat-expansion-panel>
                    <mat-expansion-panel class="mat-elevation-z0">
                        <mat-expansion-panel-header>
                            <mat-panel-title>Comment suivre mes demandes d'intervention ?</mat-panel-title>
                        </mat-expansion-panel-header>
                        <ng-template matExpansionPanelContent>
                            <p>
                                Toutes vos demandes d'intervention sont classées ici: <a routerLink="demandes">mes demandes d'intervention</a>.
                            </p>
                        </ng-template>
                    </mat-expansion-panel>
                    <!-- <mat-expansion-panel class="mat-elevation-z0">
                        <mat-expansion-panel-header>
                            <mat-panel-title>Comment modifier mes informations personnelles ?</mat-panel-title>
                        </mat-expansion-panel-header>
                        <ng-template matExpansionPanelContent>
                            <p>
                                Suivez notre guide pas à pas qui vous aidera à modifier votre profil.<br />
                                Démarrez maintenant en <a (click)="profileEditIntroReplay()">cliquant ici</a>.
                            </p>
                        </ng-template>
                    </mat-expansion-panel> -->
                    <mat-expansion-panel class="mat-elevation-z0">
                        <mat-expansion-panel-header>
                            <mat-panel-title>Comment contacter le support lors d'un problème ?</mat-panel-title>
                        </mat-expansion-panel-header>
                        <ng-template matExpansionPanelContent>
                            <div fxLayout="row" class="mat-grey" style="gap: 8px; margin-bottom: 16px">
                                <img src="assets/Backhand Index Pointing Right.png" fxFlex="0 0 24px" style="height: 24px" />
                                <p>
                                    Afin de vous proposer une meilleure prise en charge et un meilleur suivi de votre demande nous vous conseillons 
                                    <a (click)="openDemande()">l'ouverture d'une nouvelle demande d'intervention</a>.<br />
                                    Si vous ne savez pas comment procéder à l'ouverture d'une demande d'intervention, suivez notre guide pas à pas en 
                                    <a (click)="demandesIntroReplay()">cliquant ici</a>.<br />
                                </p>
                            </div>

                            Si vous avez déjà ouvert une demande d'intervention, choisissez l'une des options suivante pour contacter le support :
                            <br />

                            <ul style="padding-inline-start: 16px;">
                                <li style="margin: 8px 0">
                                    Par mail à l'adresse <strong>hotline&#64;oxance.fr</strong>.
                                </li>
                                <li style="margin: 8px 0">
                                    Par téléphone au <strong>04 76 20 27 71</strong>
                                    <ul>
                                        <li>puis faite le <mat-icon>looks_one</mat-icon> pour une assistance Portail & Intranet (Dev)</li>
                                        <li>puis faite le <mat-icon>looks_two</mat-icon> pour une assistance Materiels et mails (Infra)</li>
                                        <li>puis faite le <mat-icon>looks_3</mat-icon> pour une assistance Logiciels métier</li>
                                    </ul>
                                </li>
                            </ul>
                        </ng-template>
                    </mat-expansion-panel>
                </mat-accordion>
            </div>
        </div>

        <div class="app-section mat-grey-100 mat-fill" style="flex: 1">
            <div class="app-section-content app-socials" fxLayout="row" fxLayoutAlign="space-evenly center" style="gap: 8px">
                <a mat-icon-button *ngFor="let social of socials | keyvalue: originalOrder" 
                    [matTooltip]="social.key.capitalize()" [attr.aria-label]="social.key.capitalize()" 
                    [href]="social.value">
                    <mat-icon class="mat-grey" [svgIcon]="social.key.toLowerCase()"></mat-icon>
                </a>
            </div>
            <div class="app-section-content" fxLayout="row" fxLayoutAlign="space-evenly center" style="gap: 8px">
                <a mat-button href="https://www.oxance.fr">
                    <span class="mat-grey">www.oxance.fr</span>
                </a>
            </div>
        </div>
    </div>
    <div class="app-section app-section-xl mat-elevation-z0" style="position: relative; background: white; flex: 0 0 33%"
        [ngStyle]="{maxWidth: '360px'}"
        [ngStyle.lt-md]="{width: '100%'}">
        <mat-nav-list class="app-section-content">
            <div class="mat-title mat-accent-gradient" style="margin-left: 0;">
                Actualités
            </div>
            <ng-container *ngIf="postsActu; else waitingPosts">
                <ng-container *ngFor="let post of postsActu; trackBy: postIndex; let index = index">
                    <a mat-list-item *ngIf="post.routerLink" [routerLink]="post.routerLink">
                        <div mat-list-avatar style="width: 75px; height: 75px; border-radius: 16px; overflow: hidden;">
                            <img *ngIf="post.featuredMediaUrl" [attr.src]="post.featuredMediaUrl" [attr.alt]="post.title" loading="lazy"
                                style="width: 100%; height: 100%; object-fit: cover; object-position: center;" />
                        </div>
                        <div fxLayout="column" style="margin-left: 8px">
                            <div>{{post.title}}</div>
                            <small class="mat-grey">le {{post.date.format('DD MMM YYYY')}}</small>
                        </div>
                    </a>
                    <a mat-list-item *ngIf="post.link" [attr.href]="post.link">
                        <div mat-list-avatar style="width: 75px; height: 75px; border-radius: 16px; overflow: hidden;">
                            <img *ngIf="post.featuredMediaUrl" [attr.src]="post.featuredMediaUrl" [attr.alt]="post.title" loading="lazy"
                                style="width: 100%; height: 100%; object-fit: cover; object-position: center;" />
                        </div>
                        <div fxLayout="column" style="margin-left: 8px">
                            <div>{{post.title}}</div>
                            <small class="mat-grey">le {{post.date.format('DD MMM YYYY')}}</small>
                        </div>
                    </a>
                </ng-container>
            </ng-container>
        </mat-nav-list>
    </div>
</div>